import { render, staticRenderFns } from "./AttendancePerformanceBands.vue?vue&type=template&id=6e7f13d4&scoped=true"
import script from "./AttendancePerformanceBands.vue?vue&type=script&lang=js"
export * from "./AttendancePerformanceBands.vue?vue&type=script&lang=js"
import style0 from "./AttendancePerformanceBands.vue?vue&type=style&index=0&id=6e7f13d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7f13d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VLayout,VTextField})
